import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import slugify from 'react-slugify';

import { assetsUri } from '@/services/api.service';
import { SpecialsReq } from '@/types/request/request.types';
import { directusImageLoader } from '@/utils/loaders';

import { PriceFormat } from '../../price-format/price-format';

import styles from './deal-item.module.scss';

export const DealItem: React.FC<{
  dealInfo: SpecialsReq;
  priceCrush?: boolean;
  extraClass?: string;
  category?: string;
}> = ({ dealInfo, extraClass }) => {
  const backgroundUri = `${assetsUri}/${dealInfo?.image}?key=image-390-442`;

  const dealItemContent = (
    <div className={cn(styles.dealItemWrapper)}>
      <Image
        className={styles.dealImage}
        src={backgroundUri}
        loader={directusImageLoader}
        alt={dealInfo.title}
        layout="fill"
        priority
      />
      <div className={styles.specialInfo}>
        <h2 className={styles.modelName}>{dealInfo.title}</h2>
        <h2 className={styles.subHeading}>{dealInfo.sub_title}</h2>
        {dealInfo.discount_value && (
          <p className={styles.modelPriceInfo}>
            Save up to{' '}
            <PriceFormat value={dealInfo.discount_value} prefix="R" />
          </p>
        )}
        {/*{dealInfo.monthlyRepayment && (*/}
        {/*  <p className={styles.modelPriceInfo}>*/}
        {/*    <PriceFormat*/}
        {/*      value={dealInfo.monthlyRepayment}*/}
        {/*      prefix="R"*/}
        {/*      suffix="pm"*/}
        {/*    />*/}
        {/*  </p>*/}
        {/*)}*/}
        <div className={styles.paymentsInfo}>
          <p>{dealInfo.short_description}</p>
        </div>
      </div>
    </div>
  );

  const getVehicleTypeUrlPart = (): string => {
    return dealInfo?.vehicle_type === '4' ? 'new-cars' : 'used-cars';
  };

  const getVehicleBrandUrlPart = (): string => {
    return slugify(dealInfo?.brand?.name || 'various');
  };

  const getVehicleModelUrlPart = (): string => {
    return slugify(dealInfo?.range?.name || 'various');
  };

  const getSpecialForUrlPart = (): string => {
    let specialFor = 'various';

    if (dealInfo.special_for) {
      specialFor =
        dealInfo?.special_for === 'vehicle'
          ? 'vehicle'
          : `vehicle-${dealInfo?.special_for}`;
    }
    return slugify(specialFor);
  };

  function specialUrl() {
    const parts = ['/specials'];

    if (dealInfo.brand && dealInfo.range) {
      parts.push(getVehicleTypeUrlPart());

      parts.push(getVehicleBrandUrlPart());

      parts.push(getVehicleModelUrlPart());
    } else {
      parts.push(getVehicleTypeUrlPart());

      parts.push(getVehicleBrandUrlPart());

      parts.push(getSpecialForUrlPart());
    }

    parts.push(`${dealInfo.id}`);
    return parts.join('/');
  }

  return (
    <div
      className={cn({
        [styles[extraClass || ''] as string]: extraClass,
      })}
    >
      <Link
        href={specialUrl()}
        key={dealInfo.id}
        passHref
        className={styles.priceCrushWrapper}
      >
        {dealItemContent}
      </Link>
    </div>
  );
};
